import { defineMessages } from '@/i18n';

export const invitationsDashboardMessages = defineMessages({
  pageTitle: 'platform.app.invitations.welcome',
  noStoreFrontsOperator: 'platform.app.dashboard.emptyOperatorState.title',
  noStoreFrontsGallery: 'platform.app.dashboard.emptyGalleryState.title',
  noStoreFrontsSubtitleGallery: 'platform.app.dashboard.emptyGalleryState.subtitle',
  noInventory: 'platform.app.dashboard.empytState.recently-update-items.title',
  joinStoreFronts: 'platform.app.dashboard.emptyState.button.join',
  createStoreFronts: 'platform.app.dashboard.emptyState.button.create',
  failedToastTitleForStoreFronts: 'platform.app.dashboard.failed.failedToastTitleForStoreFronts',
  recentlyUpdateItemsUploadButton: 'platform.app.dashboard.empytState.recently-update-items.upload',
  recentlyUpdateItemsNewItemButton: 'platform.app.dashboard.empytState.recently-update-items.new-item',
  recentlyUpdateItemsTitle: 'platform.app.dashboard.recently-update-items.title',
  recentlyUpdateItemsMyItemsButton: 'platform.app.dashboard.recently-update-items.button.my-items',
  recentlyUpdateItemNewItemsButton: 'platform.app.dashboard.recently-update-items.button.new-item',
  noPendingActions: 'platform.app.dashboard.notifications.emptyState.subtitle',
  notificationTitle: 'platform.app.dashboard.notifications.title',
  statusSigned: 'platform.app.dashboard.notifications.status.signed',
  statusPending: 'platform.app.dashboard.notifications.status.pending',
  status: 'platform.app.dashboard.notifications.status',
  storefrontsHeader: 'platform.app.dashboard.storeFronts.header',
  storefrontsAndViewingRoomHeader: 'platform.app.dashboard.storefrontsAndViewingRoomHeader.header',
  storeFrontsListedItems: 'platform.app.dashboard.storeFrontsListedItems',
  storeFrontsViewingRooms: 'platform.app.dashboard.storeFrontsViewingRooms',
  newViewingRoomButton: 'platform.app.dashboard.newViewingRoomButton',
  published: 'platform.app.dashboard.published',
  unpublished: 'platform.app.dashboard.unpublished',
  public: 'platform.app.dashboard.public',
  private: 'platform.app.dashboard.private',
  publicStorefront: 'platform.app.dashboard.publicStorefront',
});
